import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navigation: React.FC = () => {
  const location = useLocation();
  const { user, logout } = useAuth();

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  const handleLogout = () => {
    logout();
  };

  const navStyle = {
    backgroundColor: '#343a40',
    color: 'white',
    padding: '1rem 0',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
  };

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 2rem'
  };

  const linkStyle = {
    textDecoration: 'none',
    color: '#adb5bd',
    fontWeight: '500',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    margin: '0 0.5rem'
  };

  const activeLinkStyle = {
    ...linkStyle,
    color: 'white',
    backgroundColor: '#007bff'
  };

  return (
    <nav style={navStyle}>
      <div style={containerStyle}>
        <Link to="/dashboard" style={{ fontSize: '1.5rem', fontWeight: 'bold', color: 'white', textDecoration: 'none' }}>
          Portfolio Admin
        </Link>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Link to="/dashboard" style={isActive('/dashboard') ? activeLinkStyle : linkStyle}>
            Dashboard
          </Link>
          <Link to="/blog" style={isActive('/blog') ? activeLinkStyle : linkStyle}>
            Blog
          </Link>
          <Link to="/analytics" style={isActive('/analytics') ? activeLinkStyle : linkStyle}>
            Analytics
          </Link>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <span style={{ color: '#adb5bd', fontSize: '0.9rem' }}>{user?.username}</span>
          <button 
            onClick={handleLogout}
            style={{
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              padding: '0.5rem 1rem',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '0.9rem'
            }}
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;